import {
    Service
  } from './index'

  export function shop_register(data) {
    return Service({
      url: '/amall_user/shop/registerShop',
      method: 'post',
      data: data
    })
  }
  //总后台 - [通用API] 根据手机号查询商户
  export function shop_list(data) {
    return Service({
      url: '/amall_user/user/appletShopByMobile',
      method: 'post',
      params: data
    })
  }
  //通用API - [通用API] 根据商户id查询该商户管理员信息
  export function shop_message(data) {
    return Service({
      url: '/amall_user/shop/findShopItem',
      method: 'post',
      params: data
    })
  }
  //修改密码
export function update_password(data) {
  return Service({
    url: '/amall_user/shop/forgetPassword',
    method: 'post',
    params: data
  })
} 


// WEBPACK FOOTER //
// ./src/service/shop_h.js